module.exports = __webpack_public_path__ + "static/cinsa_home_tu_calentador_ideal_deposito_SM-9f52aa1f8f6a0d84068cb7ab0dc75107.png";